import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#FAF8F5]" data-testid="loading-screen">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-[#D3735A] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-sm text-[#5C5855] font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  if (user === false || user === null) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
